import type {CenteredCropForAspectRatioParams, ItemCropRect} from '@PosterWhiteboard/classes/item-crop.class';

/**
 * The largest window of `aspectRatio` the media can hold, centred on it, in the media's own pixels.
 * A silent default crop for media that lands in a slot of another shape: a replaced item, a page background.
 */
export const getCenteredCropForAspectRatio = ({mediaWidth, mediaHeight, aspectRatio}: CenteredCropForAspectRatioParams): ItemCropRect => {
  const isMediaWiderThanWindow = mediaWidth / mediaHeight > aspectRatio;
  const width = isMediaWiderThanWindow ? mediaHeight * aspectRatio : mediaWidth;
  const height = isMediaWiderThanWindow ? mediaHeight : mediaWidth / aspectRatio;
  return {
    x: (mediaWidth - width) / 2,
    y: (mediaHeight - height) / 2,
    width,
    height,
    imageWidth: mediaWidth,
    imageHeight: mediaHeight,
  };
};
